export { default as Typography } from './Typography';
export { default as Colors } from './Colors';
export { default as Shadows } from './Shadows';
export { default as Animation } from './Animation';

import { ColorName as _ColorName, ColorValue as _ColorValue } from './Colors';
import {
  ShadowName as _ShadowName,
  ShadowValue as _ShadowValue,
} from './Shadows';
import { TypographyName as _TypographyName } from './Typography';

export type ColorName = _ColorName;
export type ColorValue = _ColorValue;
export type ShadowName = _ShadowName;
export type ShadowValue = _ShadowValue;
export type TypographyName = _TypographyName;
